import { t } from 'i18next';

import { getSubStepValues } from '#models/general/steps';
import Input from '#components/general/Input';
import Button from '#components/general/Button';
import AdelphiFieldsRow from '#components/business/AdelphiFieldsRow';
import TrashImage from '#assets/delete.svg';

import { NEW_PRODUCT_SUBSTEPS_IDS, TASTING_NOTES_FIELDS } from './constants';
import styles from './styles.module.scss';
import { TEMPLATES_OPTIONS } from './selectTemplate';

const newNote = (removeNote, id) => (getTastingNotesValues, getCurrentTastingNotes) =>
  [
    {
      key: `hr-${id}`,
      Component: () => <hr />
    },
    {
      key: `title-${id}`,
      Component: AdelphiFieldsRow,
      secondGrow: true,
      fields: [
        {
          key: `removeNote-${id}`,
          Component: Button,
          children: <img src={TrashImage} className={styles.deleteAlt} />,
          onClick: () => removeNote(getCurrentTastingNotes)
        },
        {
          ...getTastingNotesValues(`${TASTING_NOTES_FIELDS.TITLE}-${id}`),
          label: t(`${NEW_PRODUCT_SUBSTEPS_IDS.TASTING_NOTES}:${TASTING_NOTES_FIELDS.TITLE}`),
          Component: Input
        }
      ]
    },
    {
      ...getTastingNotesValues(`${TASTING_NOTES_FIELDS.TASTING_NOTES}-${id}`),
      label: t(`${NEW_PRODUCT_SUBSTEPS_IDS.TASTING_NOTES}:${TASTING_NOTES_FIELDS.TASTING_NOTES}`),
      Component: Input,
      rows: 3,
      noMargin: true
    },
    {
      ...getTastingNotesValues(`${TASTING_NOTES_FIELDS.NOSE}-${id}`),
      label: t(`${NEW_PRODUCT_SUBSTEPS_IDS.TASTING_NOTES}:${TASTING_NOTES_FIELDS.NOSE}`),
      Component: Input,
      rows: 3,
      noMargin: true
    },
    {
      ...getTastingNotesValues(`${TASTING_NOTES_FIELDS.PALATE}-${id}`),
      label: t(`${NEW_PRODUCT_SUBSTEPS_IDS.TASTING_NOTES}:${TASTING_NOTES_FIELDS.PALATE}`),
      Component: Input,
      rows: 3,
      noMargin: true
    }
  ];

const mapInitialTastingNote = id => ({
  component: removeNote => newNote(removeNote(id), id),
  id
});

export const mapInitialTastingNotes = ids => ids?.map(id => mapInitialTastingNote(id));

export const getTastingNotesFields = ({ setValue, values, errors, setSubStepState, subStepState }) => {
  const getTastingNotesValues = getSubStepValues(NEW_PRODUCT_SUBSTEPS_IDS.TASTING_NOTES, values, errors);

  const isPackTemplate = values?.templateType === TEMPLATES_OPTIONS.PACK;

  const getCurrentTastingNotes = () => (subStepState?.tastingNotes ? subStepState.tastingNotes : []);

  const addNote = () => {
    const lastId =
      getCurrentTastingNotes()
        .map(({ id }) => id)
        .findLast(() => true) || 0;
    const newId = lastId + 1;
    setSubStepState({
      ...subStepState,
      tastingNotes: [
        ...getCurrentTastingNotes(),
        {
          component: removeSubstep => newNote(removeSubstep(newId), newId),
          id: newId
        }
      ]
    });
  };

  const removeNote = id => () => {
    setSubStepState({
      ...subStepState,
      tastingNotes: getCurrentTastingNotes().filter(({ id: thisId }) => thisId !== id)
    });
    setValue(`tastingNotesTitle-${id}`, undefined);
    setValue(`tastingNotes-${id}`, undefined);
    setValue(`nose-${id}`, undefined);
    setValue(`palate-${id}`, undefined);
  };

  return [
    ...(getCurrentTastingNotes()?.length > 0
      ? [
          {
            ...getTastingNotesValues(`${TASTING_NOTES_FIELDS.TITLE}-0`),
            label: t(`${NEW_PRODUCT_SUBSTEPS_IDS.TASTING_NOTES}:${TASTING_NOTES_FIELDS.TITLE}`),
            Component: Input,
            rows: 3,
            noMargin: true
          }
        ]
      : []),
    {
      ...getTastingNotesValues(`${TASTING_NOTES_FIELDS.TASTING_NOTES}-0`),
      label: t(`${NEW_PRODUCT_SUBSTEPS_IDS.TASTING_NOTES}:${TASTING_NOTES_FIELDS.TASTING_NOTES}`),
      Component: Input,
      rows: 3,
      noMargin: true
    },
    {
      ...getTastingNotesValues(`${TASTING_NOTES_FIELDS.NOSE}-0`),
      label: t(`${NEW_PRODUCT_SUBSTEPS_IDS.TASTING_NOTES}:${TASTING_NOTES_FIELDS.NOSE}`),
      Component: Input,
      rows: 3,
      noMargin: true
    },
    {
      ...getTastingNotesValues(`${TASTING_NOTES_FIELDS.PALATE}-0`),
      label: t(`${NEW_PRODUCT_SUBSTEPS_IDS.TASTING_NOTES}:${TASTING_NOTES_FIELDS.PALATE}`),
      Component: Input,
      rows: 3,
      noMargin: true
    },
    ...getCurrentTastingNotes()?.flatMap(({ component }) =>
      component(removeNote)(getTastingNotesValues, getCurrentTastingNotes, values)
    ),
    ...(isPackTemplate
      ? [
          {
            key: 'addNote',
            Component: Button,
            children: t(`${NEW_PRODUCT_SUBSTEPS_IDS.TASTING_NOTES}:addNoteButton`),
            onClick: addNote,
            secondary: true
          }
        ]
      : [])
  ];
};
